import { apiCall } from '../axios';
import { API_CONSTANTS } from '../../services/apiConstants';
import {
    DriverLoadEarning,
    ISettlementReport,
} from './interface/ISettlementReport';
import {
    ApiCallRequestTypes,
    ContentTypeConstants,
    CUSTOM_AXIOS_TIMEOUT,
} from '../../utils/constants';

const fetchNewSettlementReport = async ({
    driverLoadIds,
}: {
    driverLoadIds?: number[] | null;
}): Promise<ISettlementReport[]> => {
    const params = new URLSearchParams();

    if (driverLoadIds?.length) {
        params.set('driverLoadIds', driverLoadIds.join(','));
    }

    const response = await apiCall(
        'get',
        `${API_CONSTANTS.reports}${API_CONSTANTS.settlements}${
            API_CONSTANTS.driverLoadIds
        }?${params.toString()}`,
        {},
        true,
        false,
        false,
        ContentTypeConstants.json,
        CUSTOM_AXIOS_TIMEOUT,
    );
    return response.data;
};

const fetchSettlementReport = async ({
    startDate,
    endDate,
}: {
    startDate: string;
    endDate: string;
}): Promise<ISettlementReport[]> => {
    const response = await apiCall(
        'get',
        `${API_CONSTANTS.reports}${API_CONSTANTS.settlements}?startDate=${startDate}&endDate=${endDate}`,
        {},
        true,
    );
    return response.data;
};

const fetchCommissionReport = async ({
    startDate,
    endDate,
}: {
    startDate: string;
    endDate: string;
}): Promise<Blob> => {
    const response = await apiCall(
        'get',
        `${API_CONSTANTS.reports}/${startDate}/${endDate}`,
        {},
        true,
        true,
        false,
        ApiCallRequestTypes.excelFormat,
    );
    return response.data;
};

const fetchDeathLossReport = async ({
    startDate,
    endDate,
}: {
    startDate: string;
    endDate: string;
}): Promise<Blob> => {
    const response = await apiCall(
        'get',
        `${API_CONSTANTS.reports}${API_CONSTANTS.deathLoss}/${startDate}/${endDate}`,
        {},
        true,
        true,
        false,
        ApiCallRequestTypes.excelFormat,
    );
    return response.data;
};

const fetchTrailerIncomeReport = async ({
    startDate,
    endDate,
}: {
    startDate: string;
    endDate: string;
}): Promise<Blob> => {
    const response = await apiCall(
        'get',
        `${API_CONSTANTS.reports}${API_CONSTANTS.trailerincome}/${startDate}/${endDate}`,
        {},
        true,
        true,
        false,
        ApiCallRequestTypes.excelFormat,
    );
    return response.data;
};

const createDriverLoadEarning = async (
    payload: DriverLoadEarning,
): Promise<number> => {
    const response = await apiCall(
        'post',
        `${API_CONSTANTS.reports}${API_CONSTANTS.driverLoadEarning}`,
        payload,
        true,
    );

    return response.data;
};

const sendSettlementToQuickBooks = async (
    settlementIds: number[],
): Promise<number> => {
    const response = await apiCall(
        'post',
        `${API_CONSTANTS.reports}${API_CONSTANTS.settlements}${API_CONSTANTS.publishRequest}`,
        settlementIds,
        true,
    );

    return response.status;
};

export const reportApi = {
    fetchNewSettlementReport,
    fetchSettlementReport,
    fetchCommissionReport,
    fetchDeathLossReport,
    fetchTrailerIncomeReport,
    createDriverLoadEarning,
    sendSettlementToQuickBooks,
};
